<template>
  <div class="">
    
    <PageHeader label="Upload Application to Mercury"></PageHeader>

    <div class="mt-8">
      <template v-if="isAuthOk == null">
      </template>

      <template v-if="isAuthOk == false">
        <div class="text-base leading-normal bg-red-100 border border-red-500 p-4 w-full lg:w-1/2">
          We could not authenticate your Mercury login details.
          Please make sure that you have saved the correct login details 

          <router-link :to="{ 
            name : 'broker-integration', 
            params : {
              brokerId : $store.state[$store.state.view + 'Module'].broker.id
            }
          }"
          tag="a"
          class="text-red-600 underline font-semibold">here</router-link>. 

          <br/><br/>

          Please also make sure that you can successfully 
          <a href="https://m5.connective.com.au/mercury5/" class="text-red-600 underline font-semibold" target="_blank">login to Mercury</a> 
          through its website.

          <div class="mt-8">
            <router-link :to="{ 
              name : 'broker-integration', 
              params : {
                brokerId : $store.state[$store.state.view + 'Module'].broker.id
              }
            }"
            tag="a"
            class="inline-block text-white bg-red-500 p-4 rounded font-semibold">Update my Mercury login details</router-link>
          </div>

        </div>
      </template>

      <template v-if="isAuthOk == true">

        <template v-if="uploading">
          <div class="bg-gray-200 p-8 text-sm text-gray-900 inline-block mt-4 rounded">
            <div class="blink">Uploading to Mercury in progress...</div>
            <div class="mt-3">Please be patient. This could take a few minutes</div>
          </div>
        </template>

        <template v-else>

          <div class="px-4 pt-4 bg-gray-200 border border-gray-500 overflow-hidden text-sm" style="padding-bottom:14px;">
            <div class="float-left" style="margin-top:2px;">
              <img src="/static/img/icons/icons8-info.png" 
              style="width:18px;" />            
            </div>

            <div style="margin:-1px 0 0 28px;" class="leading-normal">
              {{ getAppName }} can upload your client's various details to your Mercury account automatically.
              Please specify how you would like this upload to be done below.
            </div>
          </div>

          <div class="mt-12 text-2xl font-thin">
            Creating / updating opportunity
          </div>

          <div class="mt-4 text-sm leading-normal">
            Based on the client information, we can create a new opportunity in Mercury or we can update an existing
            opportunity for this client if it is in Mercury already.
          </div>

          <div class="mt-2 text-sm leading-normal">
            <b>IMPORTANT</b> - Opportunities that were created manually in Mercury won't be found by Brokerpad. Therefore create new Opportunities here.
          </div>

          <div class="mt-4 overflow-hidden text-sm">
            <div class="float-left" style="margin:2px;">
              <input type="radio" v-model="createOrUpdateOpportunity" value="create" id="inputOpportunityCreate" />
            </div>
            
            <div class="float-left" style="margin:3px 0 0 5px;">
              <label for="inputOpportunityCreate">Create a new opportunity</label>
            </div>
          </div>

          <div class="mt-2 overflow-hidden text-sm">
            <div class="float-left" style="margin:2px;">
              <input type="radio" v-model="createOrUpdateOpportunity" value="update" id="inputOpportunityUpdate" :disabled="opportunityId == null" />
            </div>

            <div class="float-left" style="margin:3px 0 0 5px;">
              <label for="inputOpportunityUpdate">Update an existing opportunity</label>
            </div>

            <div v-if="opportunityId == null" class="float-left text-red-500" style="margin:3px 0 0 20px;">
              [No existing opportunity found]
            </div>
          </div>





          <div class="mt-12 text-2xl font-thin">
            Add / update applicant's details
          </div>

          <div class="mt-4 text-base leading-normal">
            {{ getAppName }} can search your Mercury account to see if any of the applicants 
            already exist. If yes, {{ getAppName }} will update its information. If applicant
            does not exist, {{ getAppName }} can create new entry with the latest information.
          </div>


          <div class="flex flex-wrap mt-8 text-sm">
            <div class="w-1/4 overflow-hidden">
              <div class="float-left">
                <input type="checkbox" v-on:change="checkAllApplicants($event.target)" checked="true" />
              </div>

              <div class="float-left" style="margin:1px 0 0 8px;">
                <div class="font-semibold text-gray-700">Applicant name</div>
              </div>
            </div>

            <div class="w-1/4">
              <div class="font-semibold text-gray-700">Email</div>
            </div>

            <div class="w-1/4">
              <div class="font-semibold text-gray-700">Mobile</div>
            </div>

            <div class="w-1/4">
              <div class="font-semibold text-gray-700">Update / Create</div>
            </div>
          </div>

          <div class="">
            <template v-for="(applicant, index) in applicants">

              <div class="flex flex-wrap text-sm border-t pt-2 mt-2">
                <div class="w-1/4 overflow-hidden">
                  <div class="float-left">
                    <input type="checkbox" v-model="applicant.upload" />
                  </div>

                  <div class="float-left" style="margin:1px 0 0 8px;">
                    {{ applicant.name }}
                  </div>
                </div>

                <div class="w-1/4">
                  {{ applicant.email  ? applicant.email   : '[Email not provided]' }} 
                </div>

                <div class="w-1/4">
                  {{ applicant.phone ? applicant.phone  : '[Mobile phone not provided]' }}
                </div>

                <div class="w-1/4">
                  <template v-if="applicant.uniqueId != null">
                    Found in Mercury, will be updated
                  </template>

                  <template v-else>
                    Not in Mercury, will be created
                  </template>
                </div>
              </div>
            </template>
          </div>


          <div class="mt-12 text-2xl font-thin">
            Client summary report
          </div>

          <div class="mt-4 text-sm">
            <div class="overflow-hidden">
              <div class="float-left">
                <input type="checkbox" v-model="uploadSummary" id="inputUploadSummary" />
              </div>

              <label class="block" for="inputUploadSummary" style="margin:1px 0 0 20px;">
                {{ getAppName }} will upload a client summary report available as a PDF file.
                You can preview this file 
                <a :href="getBackendHost + '/api/report/preview/' + $route.params.clientId + '?token=' + getJwt" 
                  class="text-blue-600 no-underline hover:underline"
                  target="_blank">here</a>.
              </label>
            </div>
          </div>

          <div class="mt-12 text-2xl font-thin">
            Client documents
          </div>

          <div class="mt-4 text-sm">
            <div class="overflow-hidden">
              <div class="float-left">
                <input type="checkbox" v-model="uploadDocuments" id="inputUploadDocuments" />
              </div>

              <label class="block" for="inputUploadDocuments" style="margin:1px 0 0 20px;">
                Select this to upload all relevant client documents to Mercury.
              </label>
            </div>
          </div>




          <div class="button-line">
            <SubmitButton label="Upload to Mercury" :onClick="submit" :loading="loading"></SubmitButton>
          </div>

          <br/><br/><br/>
        </template>

      </template>
    </div>

    <v-dialog />
  </div>
</template>

<script>
  import axios          from "axios"
  import { EventBus }   from '@/shared/event-bus';
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import SubmitButton   from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton,
      PageHeader,
    },

    data () {
      return {
        isAuthOk                 : null,
        opportunityId            : null,
        loading                  : false,
        uploading                : false,
        applicants               : [],
        uploadSummary            : true,
        uploadDocuments          : true,
        createOrUpdateOpportunity: 'create'
      }
    },

    created() {
      this.initializing = true
      this.showLoader("Initializing ...")

      // check mercury - check for auth, opp, contacts
      this.apiPost({
        clientId : this.$route.params.clientId
      }, 'mercury/check-mercury', (data) => {

        this.hideLoader()

        this.isAuthOk                  = true
        this.opportunityId             = null
        this.createOrUpdateOpportunity = 'create'
        
        // token is invalid - something is wrong
        if(data.token == null || data.token.length == 0) {  
          this.isAuthOk = false
        }

        else {

          if(data.opportunityId != null && data.opportunityId.length > 0) {
            this.opportunityId             = data.opportunityId
            this.createOrUpdateOpportunity = 'update'
          }

          this.applicants = data.applicants
        }
      })
    },

    methods : {
      checkAllApplicants(target) {
        this.applicants.forEach( (applicant) => {
          applicant.upload = target.checked
        })
      },

      // we are going through the below callbacks, because sometimes each request is too slow
      // so we are separating the entire process into 3 chunks
      submit() {
        this.$modal.show('dialog', {
          title  : 'Ready to upload to Mercury',
          text   : "We are now ready to upload your client's data to Mercury. Please be aware that this process can take up to several minutes.",
          buttons: [{
            title: 'OK',
            handler: () => { 
              this.$modal.hide('dialog')
              this.uploading = true

              // first upload contacts
              this.apiPost({
                clientId                 : this.$route.params.clientId,
                applicants               : this.applicants,
                uploadSummary            : this.uploadSummary,
                uploadDocuments          : this.uploadDocuments,
                opportunityId            : this.opportunityId,
                createOrUpdateOpportunity: this.createOrUpdateOpportunity
              }, 'mercury/upload-contacts', (firstResponse) => {

                // second upload opportunities
                this.apiPost({
                  clientId                 : this.$route.params.clientId,
                  applicants               : this.applicants,
                  uploadSummary            : this.uploadSummary,
                  uploadDocuments          : this.uploadDocuments,
                  opportunityId            : this.opportunityId,
                  createOrUpdateOpportunity: this.createOrUpdateOpportunity,
                  integrationId            : firstResponse.integrationId
                }, 'mercury/upload-opportunities', (secondResponse) => { 

                  // third upload documents               
                  this.apiPost({
                    clientId                 : this.$route.params.clientId,
                    applicants               : this.applicants,
                    uploadSummary            : this.uploadSummary,
                    uploadDocuments          : this.uploadDocuments,
                    opportunityId            : this.opportunityId,
                    createOrUpdateOpportunity: this.createOrUpdateOpportunity,
                    integrationId            : firstResponse.integrationId,
                    uniqueId                 : secondResponse.uniqueId
                  }, 'mercury/upload-documents', (data) => { 
                    this.uploading = false
                    this.$router.push({
                      name  : 'application-mercury-results',
                      params: {
                        clientId : this.$route.params.clientId
                      }
                    })
                  })
                })
              })
            }
          }]
        })
      },
    }
  }
</script>